export const hasLangCodeParam = (url: string): boolean => {
  const urlObj = new URL(url);
  return urlObj.searchParams.has('langCode');
};
